import axios from 'axios';

import routes from 'app/routes';

export default {
  updateEmail: (values, successCallback, errorCallback) => {
    axios
      .put(routes.api.members.settings.updateEmail, { user: values })
      .then((resp) => {
        successCallback(resp.data.data);
      }).catch((error) => {
        errorCallback(error.response.data);
      });
  },
  updatePassword: (values, successCallback, errorCallback) => {
    axios
      .put(routes.api.members.settings.updatePassword, { user: values })
      .then((resp) => {
        successCallback(resp.data.data);
      }).catch((error) => {
        errorCallback(error.response.data);
      });
  },

  requestDelete: (callback) => {
    axios
      .post(routes.api.members.settings.requestDelete)
      .then(() => {
        callback();
      });
  },

  updateCalendars: (values, callback) => {
    Promise.all([
      axios
        .post(routes.api.slack.updateChannel, {
          user_id: values.slack_user_id,
          channel_id: values.slack_channel_id,
        }),
      axios
        .post(routes.api.users.calendars.update, values),
    ]).then(() => {
      callback(true);
    }).catch(() => {
      callback(false);
    });
  },

  createVectorStorage: (callback) => {
    axios
      .post(routes.api.members.vector_storages.create)
      .then((resp) => {
        callback(resp.data.data);
      });
  },

  unlinkSlack: (slackUserId, callback) => {
    axios
      .delete(routes.api.slack.unlink, {
        data: {
          user_id: slackUserId,
        },
      })
      .then(() => {
        callback(true);
      }).catch(() => {
        callback(false);
      });
  },

};
